<script>
import forminput from "../formcomponet/forminput.vue"; 
import formtextarea from "../formcomponet/formtextarea.vue";
import Loader from "@/components/widgets/loader";
import apibtoast from "@/helpers/apibtoast";
import apigeneric from "@/helpers/apigeneric";
import newstranslations from "@/models/newstranslations";
import appConfig from "@/app.config";
import CKEditor from "@ckeditor/ckeditor5-vue";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import VueTagsInput from '@johmun/vue-tags-input';
import { get } from "http";
 
export default {
  mixins: [apibtoast, apigeneric, newstranslations,appConfig],
  props: ["lang_id","news_id","Websiteid"],
  data() { 
    return {
       tag: '',
      tags: [],
      FormData: [],
      editor: ClassicEditor,
      editorData: "",
      imagelist:[],
      visible: false,
      singleImage: false,
      visibleCaption: false,
      index: 0, // default: 0
      imgs: [],
      dosya_eklendi:0,
       DefaultPage: 1,
      Page: {
        PageNumber: "1",
        PageSize: "10",
        PageDataSize: "1",
      },
      kontrol:"",
  
    };
  },
  components: {
    Loader,
    forminput, 
    formtextarea,
    ckeditor: CKEditor.component,
    VueTagsInput

  },
  watch: {

    lang_id(){
      this.FormData=this.newstranslationsData;
      get();
    }

  },
  methods: {
    onSubmit() {
       
        this.FormData.Websiteid="34a035fe-de82-406b-a444-9cf9140bcd81";

          this.FormData.SeoKeywords = JSON.stringify(this.tags);

          this.FormData.Websiteid=this.Websiteid;
          this.FormData.Newsid=this.news_id;
          this.FormData.Langid=this.lang_id;
  


      this.$v.$touch();
      if (!this.$v.$invalid) {  


            if (this.FormData.Id == "" || this.FormData.Id == null) {
            
              this.Post("NewsTranslations", this.FormData).then((res) => {
                if (res) {
              
                    this.$emit("TableUpdate");           
                }
              });

            } else {

              this.Update("NewsTranslations", this.FormData).then((res) => {
                if (res) {   
                
                  this.$emit("TableUpdate");
                }
              });
            }
        
      }
    },

    Get() {

      let Filter = "&Langid="+this.lang_id+"&Newsid="+this.news_id;
      console.log(Filter)

      this.ActionsFilterGet({ Service: "NewsTranslations", Page: this.Page, Filter: Filter }).then((res) => {

        if(res.Data.length>0){
          
        this.FormData = res.Data[0];
 

        this.tags=[];

            if ( this.FormData.SeoKeywords != null && this.FormData.SeoKeywords != "") {


                  this.tags = JSON.parse(this.FormData.SeoKeywords);  

                }  
                

        } else{
             this.FormData=this.newstranslationsData;
        }


    }); 
    },


  },
};
</script>
<template>
  <Loader>


      <Form @submit.prevent="onSubmit"> 

        <div class="row">
          <div class="col-md-12">

               <forminput
                :FormDataType="FormDataType.Title"
                :Value="FormData.Title"
                :v="$v.FormData.Title"
                @input="FormData.Title = $event"
              /> 
           
          </div>
          
        </div>

          <div class="row">
          <div class="col-md-12">
            <b-form-group
              :class="title_position"
              :label-cols-lg="labels_lg"
              id="example text"
              :label="FormDataType.Description.FieldTitle"
              label-for="text"
            >  
                 <ckeditor v-model="FormData.Description" :editor="editor"></ckeditor>
            </b-form-group>
            </div>          
          </div>
<br>
<br>
 
     <h4>{{this.$t('dpages.AddEdit.SeoAyarlari')}}</h4>
  <hr/>

        <div class="row">
          <div class="col-md-6">

              <forminput
                :FormDataType="FormDataType.SeoTitle"
                :Value="FormData.SeoTitle"
                :v="$v.FormData.SeoTitle"
                @input="FormData.SeoTitle = $event"
              /> 
           
          </div>
          
        </div>
        <div class="row">
          <div class="col-md-12">

            <b-form-group
              id="example text"
              :label="FormDataType.SeoKeywords.FieldTitle"
              label-for="text"
            >
            <vue-tags-input
              style="max-width: unset;"
              placeholder=""
              v-model="tag"
              :tags="tags"
              @tags-changed="newTags => tags = newTags"
            />
            </b-form-group>

          </div>
        </div>

        <div class="row">
          <div class="col-md-12">

            <formtextarea
              :FormDataType="FormDataType.SeoDescription"
              :Value="FormData.SeoDescription"
              :v="$v.FormData.SeoDescription"
              @input="FormData.SeoDescription = $event"
            />
           
          </div>
          
        </div>


 
        <button class="btn btn-primary" type="submit">
          {{ $t("dpages.AddEdit.Button") }}
        </button>
      </Form>




  </Loader>
</template>
